import { Button, Tooltip } from 'antd';
import './MapPopup.less';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import {
  deleteGeometry,
  editGeometry,
  selectGeometrySelected,
  unselectGeometry,
} from '../../../store/slice/mapSlice';
import Icon from '@ant-design/icons';
import { Geometry, LatLong, Line, Point, PointColors, Polygon } from '../../../models/Geometries';
import { Popup } from 'react-map-gl';
import moment from 'moment';
import { ReactComponent as ColorIcon } from '../../../res/svg/color.svg';
import { ReactComponent as EditIcon } from '../../../res/svg/edit-filled.svg';
import { ReactComponent as RemoveIcon } from '../../../res/svg/remove.svg';
import { BlockPicker } from 'react-color';
import { useState } from 'react';
import GeometryEditModal from '../../Organisms/PointEditModal/GeometryEditModal';


function MapPopup() {
  const geometrySelected: Geometry | undefined = useAppSelector(selectGeometrySelected) as any;
  const dispatch = useAppDispatch();
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const canEditGeometries = useAppSelector(state => state.task.canEditGeometries);

  let longitude = 0, latitude = 0;
  if(geometrySelected?.tipo === 'punto') {
    latitude = (geometrySelected as Point).latitud
    longitude = (geometrySelected as Point).longitud
  }
  if(geometrySelected?.tipo === 'linea' || geometrySelected?.tipo === 'poligono') {
    let maxLatPoint: LatLong = {latitud: -90, longitud: 0};
    (geometrySelected as Line | Polygon).puntos.forEach(p => {
      if(p.latitud > maxLatPoint.latitud) {
        maxLatPoint = p;
      }
    })
    latitude = maxLatPoint.latitud;
    longitude = maxLatPoint.longitud;
  }


  return geometrySelected ? (
    <div className='at-map-popup__container'>
      <Popup key={geometrySelected.id} closeOnClick={false} focusAfterOpen={true} closeButton={false}
             longitude={longitude ?? 0} latitude={latitude ?? 0}
             anchor='bottom' maxWidth={'400px'}
             style={{
               top: geometrySelected.tipo === 'punto' ? -40 : -1,
             }}
             closeOnMove={false}
             onClose={() => {
               setShowColorPicker(false);
             }}>
        <h1 className='at-map-popup__title'>{geometrySelected.titulo}</h1>
        <div className='at-map-popup__created-by'>
          Creada por <b>{geometrySelected.createdBy}</b> {moment(geometrySelected.fechaCreacion).format('DD/MM/YYYY')}
        </div>
        <div className='at-map-popup__description'>
          {geometrySelected.descripcion ? geometrySelected.descripcion :
            canEditGeometries ? 'Presiona botón editar para agregar una descripción a la tarea.' : '-'}
        </div>
        {canEditGeometries ? <div className='at-map-popup__buttons'>
          <Tooltip title={'Color'} placement={'bottom'}>
            <Button
              className={'at-map-popup__button ' + (showColorPicker ? 'selected' : '')}
              size='large'
              shape='round'
              onClick={() => {
                setShowColorPicker(!showColorPicker);
              }}
              type={'ghost'}
              icon={<Icon component={ColorIcon} />}
            >
            </Button>
          </Tooltip>
          <Tooltip title={'Editar'} placement={'bottom'}>
            <Button
              className={'at-map-popup__button'}
              size='large'
              shape='round'
              onClick={() => setShowEdit(true)}
              type={'ghost'}
              icon={<Icon component={EditIcon} />}
            >
            </Button>
          </Tooltip>
          <Tooltip title={'Eliminar'} placement={'bottom'}>
            <Button
              className={'at-map-popup__button'}
              size='large'
              shape='round'
              onClick={() => dispatch(deleteGeometry())}
              type={'ghost'}
              icon={<Icon component={RemoveIcon} />}
            >
            </Button>
          </Tooltip>
        </div> : null}
        {showColorPicker ? (<div className='at-map-popup__colorpicker-container'>
          <BlockPicker color={geometrySelected.color} onChangeComplete={e => dispatch(editGeometry({
            title: geometrySelected?.titulo,
            description: geometrySelected?.descripcion,
            color: e.hex
          }))}
                       colors={PointColors} className='at-map-popup__colorpicker' />
        </div>) : null}
        <GeometryEditModal isModalVisible={showEdit} geometry={geometrySelected}
                           closeModal={() => setShowEdit(false)} />
      </Popup>


    </div>

  ) : null;
}

export default MapPopup;
